import Vue from 'vue'
import Request from '@Utils/request'
import Dispatcher from '@Utils/dispatcher'
import components from '../components'
import Modules from '../modules'

export default class App {
  constructor () {
    this.request = Request
    this.dispatcher = new Dispatcher()
  }

  init (url) {
    this.url = url;

    this.vue = new Vue({
      el: '#app',
      url,
      components
    })

    this.menu = new Modules.MMenu('#offcanvas');
    this.waves = new Modules.WaveEffect();
    this.inview = new Modules.InView();

    //- Setup observers
    this.inview.observe('[data-role="google-map"]', async (el) => {
      const Map = await import('../modules/map' /* webpackChunkName: "js/modules/google-map" */ );
      this.map = new Map.default();
    });

    this.inview.observe('img[data-src]', (img) => {
      img.src = img.dataset.src
    });

    this.inview.observe('#newsletter', (el) => {
      el.className = "visible"
    });
  }
}



// WEBPACK FOOTER //
// ./resources/js/core/index.js